import React from "react";
import { Text, Button } from "@mantine/core";
import { OdpBlockedDatesContext } from "../../providers/BlockedDatesProvider";
import { OdpBlockedDateContextType } from "../../@types/blockedDates";

export const NoBlockedDates: React.FC = () => {
  const { setIsCreateNew } = React.useContext(
    OdpBlockedDatesContext
  ) as OdpBlockedDateContextType;
  return (
    <div className="empty-state">
      <div className="empty-state-container">
        <Text className="empty-state-heading" style={{ width: "initial" }}>
          You can block your EWA limits
        </Text>
        <Text className="empty-state-paragraph">
          You can select dates each month when your employees will not be able
          to take advances.
        </Text>

        <Button
          onClick={() => setIsCreateNew(true)}
          type="button"
          variant="filled"
          className="btn-text"
          color="jem-theme"
        >
          Create New
        </Button>
      </div>
    </div>
  );
};
